import { render, staticRenderFns } from "./aStaffCommunityList.vue?vue&type=template&id=27b23a4c&scoped=true"
import script from "./aStaffCommunityList.vue?vue&type=script&lang=js"
export * from "./aStaffCommunityList.vue?vue&type=script&lang=js"
import style0 from "./aStaffCommunityList.vue?vue&type=style&index=0&id=27b23a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b23a4c",
  null
  
)

export default component.exports